import React from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode'

import {TenantFrontendApi_GetReseller} from "./TenantFrontendApi";

import HomePage from "./HomePage"
import Reseller from "./Reseller"
import Tenant from "./Tenant"
import EditUser from "./EditUser"
import Users from "./Users"
import EditTenant from "./EditTenant"
import Licences from "./Licences"
import BuyLicence from "./BuyLicence"
import AddNewTenant from "./AddNewTenant"
import TenantUsers from "./TenantUsers"
import AddNewUser from "./AddNewUser"
import TenantLicences from "./TenantLicences"
import DefaultSettings from "./DefaultSettings"
import Footer from "./Footer"
import User from "./User"
import Error from "./Error"
import Support from "./Support"
import SuperTenant from './SuperTenant'

import './App.css'

//IMPORTANT!!
//Signin via the https://signin-va.cloudcti.nl/signin/onelogin ONLY works if the app runs in a *.cloudcti.nl domain
//It will NOT work in a localhost environment, and it will NOT work in an *.azurewebsites.net environment
//For these latter purposes, the debug lines in the App() can be used to force a user

function App() {

  //sessionStorage.setItem("username","Arash Reseller")
  //sessionStorage.setItem("token","eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTaWduaW5NZXRob2QiOiJDbG91ZENUSSIsIlNpZ25pblVzZXIiOiJwcm92aWRlcmFyYXNoQGNsb3VkY3RpLm5sIiwiU2lnbmluUGFzc3dvcmQiOiJRR1VuSmlyU3RvQTAwTjdLYU00aEtPV2ZYNkhvRFR4RjEvM0RMczkzRDVDUkRYN0xTTWhmVHJWd21nS2plcXNIQkhrSHF4UzBWbDUrNmZ5bmxkM3FIb0IyRXp4T09RR1FYNXk4bFdzN0dxVmtvTFJ4cXVycGh2QW5FejdNZWFqZCIsIlNpZ25pbkFwcGxpY2F0aW9uIjoiUmVzZWxsZXJQb3J0YWwiLCJUZW5hbnRHdWlkIjoiVGVuYW50XzgwNGM2NDQ4LWIyZGItNDQ5MC05MzI5LTVjMzBiMDllYmQ2ZCIsIlRlbmFudE5hbWUiOiJQcm92aWRlciBBcmFzaCIsIlVzZXJHdWlkIjoiVGVuYW50VXNlcl85ODY2ZWM1Ny1jYWE2LTRiMGMtOTk3MC1kNTJhZWY4OGQwNmYiLCJVc2VyTmFtZSI6IlByb3ZpZGVyIEFyYXNoIHBvcnRhbCBhY2NvdW50IiwiVXNlcklzQWRtaW4iOiIwIiwiVXNlcklzVGVuYW50QWRtaW4iOiIwIiwiRW1haWwiOiJwcm92aWRlcmFyYXNoQGNsb3VkY3RpLm5sIiwiUmVzZWxsZXJPd25lckd1aWQiOiJSZXNlbGxlcl84RjREMDlGQS1GMjQ4LTREQzMtQTQyNi05QTgyOTMzNkM0MDciLCJSZXNlbGxlckd1aWQiOiJSZXNlbGxlcl83NDQ4OTZFMy1GNjgxLTQ0OTktODIxQS0yQTk4MUE5OEQwODMiLCJJc1N1cGVyVGVuYW50IjoiMCIsIlJvbGVzIjoiVXNlcixSZXNlbGxlciIsImV4cCI6MTc4MzU4OTU5NiwiaXNzIjoic2lnbmluLXZhIiwiYXVkIjoiQ2xvdWRDVEkyMDIyIn0.-xiI3VfDqo3K4Rj4fZFtvqxIde416xMTZWGEp1SmPcM")

  const token = Cookies.get("resellerportal")
  //const token = sessionStorage.getItem("token")

  if (token) {
    try
    {
      const decodedToken = jwtDecode(token);
      
      sessionStorage.setItem("username", decodedToken.UserName);
      sessionStorage.setItem("token", token);

      // Log in as a reseller(super tenant)
      if(decodedToken.IsSuperTenant === "1")
      {
        console.log("Super tenant account detected.")
        sessionStorage.setItem("IsSuperTenant","1")
        sessionStorage.setItem("resellerguid",decodedToken.SuperTenantResellerGuid)
        sessionStorage.setItem("SuperTenantGuid",decodedToken.TenantGuid)
        sessionStorage.setItem("ManageTenants",decodedToken.SuperTenantManageTenants)
        sessionStorage.setItem("ManageLicenses",decodedToken.SuperTenantManageLicences)
        sessionStorage.setItem("UserGuid",decodedToken.UserGuid)
      }

      //Get and save the reseller
      if(decodedToken.IsSuperTenant !== "1")
      {
        sessionStorage.setItem("resellerguid",decodedToken.ResellerGuid)
        GetReseller();
        sessionStorage.setItem("ManageLicenses","1")
      }

    }

    catch (error)
    {
      console.error("Error decoding token:", error);
    }
  }

  async function GetReseller()
  {
    try
    {  
        const ResellerResponse = await TenantFrontendApi_GetReseller(sessionStorage.getItem("token"),sessionStorage.getItem("resellerguid"))
        sessionStorage.setItem("reseller",ResellerResponse.data)

        const maxDemoTenants = ResellerResponse.data.MaxDemoTenants ?? 0;
        sessionStorage.setItem("maxdemotenants", maxDemoTenants);
    }

    catch (ex)
    {
        let errorMessage = "An error occurred while fetching the reseller.";
        if (ex.response && ex.response.data && ex.response.data.Exception)
        {
            errorMessage += ` Details: ${ex.response.data.Exception}`;
        }
        else if (ex.message) {
            errorMessage += ` Message: ${ex.message}`;
        }
        else
        {
            errorMessage += " No additional information is available.";
        }
        console.error(errorMessage);
    }
  }

  if (sessionStorage.getItem("token"))
  {
      return (
        <Router>
          <Routes>
            <Route path="/edittenant" element={<EditTenant/>} />
            <Route path="/tenant" element={<Tenant/>}/>
            <Route path="/reseller" element={<Reseller/>} />
       x    <Route path="/" element={<HomePage/>} />
            <Route path="/edituser" element={<EditUser/>} />
            <Route path="/users" element={<Users/>} />
            <Route path="/licences" element={<Licences/>} />
            <Route path="/buylicence" element={<BuyLicence/>} />
            <Route path="/addnewtenant" element={<AddNewTenant/>} />
            <Route path="/tenantusers" element={<TenantUsers/>} />
            <Route path="/addnewuser" element={<AddNewUser/>} />
            <Route path="/tenantlicences" element={<TenantLicences/>} />
            <Route path="/defaultsettings" element={<DefaultSettings/>} />
            <Route path="/footer" element={<Footer/>}/>
            <Route path="/user" element={<User/>}/>
            <Route path="/error" element={<Error/>}/>
            <Route path="/support" element={<Support/>}/>
            <Route path="/supertenant" element={<SuperTenant/>}/> 
          </Routes>
        </Router>
      );
    }

    else
    {   
      //const redirecturl = window.location.href.replaceAll(":","%3A").replaceAll("/","%2F").replaceAll("&","%26")   
      const redirecturl = window.location.protocol + '//' + window.location.host  
      window.location.href = "https://signin-va.cloudcti.nl/signin/onelogin?clientid=resellerportal&redirecturl=" + redirecturl
    }  
}

export default App;
